import React from 'react'

const CorporateClients = () => {
  return (
    <section>
        <h1>CorporateClients</h1>
    </section>
  )
}

export default CorporateClients